/* vr-product-recommendations.js — fills sections/vr-product-recommendations.liquid.
   Shopify only populates the `recommendations` object when the section is rendered through
   the Section Rendering API, so the page load leaves an empty root carrying that URL; this
   fetches the section, swaps the rendered row in, and hands it to vr-product-carousel.js
   (window.vrCarousel) for the arrows and counter. No recommendations = the root stays hidden.
   Vanilla ES6, no jQuery (project rule). Re-runs on shopify:section:load. */
(function () {
  'use strict';

  if (window.__vrRecs) return;
  window.__vrRecs = true;

  function fill(root) {
    var url = root.getAttribute('data-vr-recs-url');
    if (!url || root.__vrRecsDone) return;
    root.__vrRecsDone = true;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-vr-recs]');
        var row = fresh && fresh.querySelector('[data-vr-carousel-cell]');
        if (!row) { root.hidden = true; return; }
        root.innerHTML = fresh.innerHTML;
        root.hidden = false;
        /* The card images are rimg `data-rimg="lazy"`, and Atlantic's rimg only tracks what was in
           the DOM at load: fetched cards kept their blank SVG placeholder. This is rimg-shopify's
           own public hook (atlantic.js, init: document listens for theme:rimg:watch and watches
           event.target), so it bubbles from the root. A plain DOM event, no jQuery. */
        root.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
        if (window.vrCarousel && window.vrCarousel.init) window.vrCarousel.init(root);
      })
      .catch(function () { root.hidden = true; });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vr-recs]').forEach(fill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
